import React from 'react';
import './styles.scss';
import { Outlet } from 'react-router-dom';
import Sidebar from 'components/sidebar';
import Header from 'components/header';
import useDashboardContext from 'contexts/dashboard.context';
import AddStoreModal from 'components/modals/add-store-modal';

const DashboardContent = () => {
  const { backLinkTitle, hideSideBar, showAddStoreModal, setShowAddStoreModal } =
    useDashboardContext();

  return (
    <div className={`dashboard min-h-screen flex  overflow-x-hidden`}>
      {!hideSideBar && (
        <div className='max-lg:hidden'>
          <Sidebar />
        </div>
      )}
      <div className='w-full flex flex-col h-screen'>
        <Header title={backLinkTitle} />
        <div className='p-4 pt-6'>
          <Outlet />
        </div>
      </div>
      <AddStoreModal show={showAddStoreModal} onClose={() => setShowAddStoreModal(false)} />
    </div>
  );
};

export default DashboardContent;
